// @flow

import type { Bundle } from '../../../types/pdb';
import type { State } from '../types';

import {
  getPdbItem,
} from './main';

type GlobalState = {
  pdb: State,
};

export const getBundles = (state: GlobalState, pdbId: ?string = null): Bundle[] => {
  const pdbItem = getPdbItem(state, pdbId);
  return pdbItem.extraBundles || [];
};

export const getBundleById = (
  state: GlobalState,
  pdbId: ?string = null,
  bundleId: ?number = null,
): ?Bundle => {
  const bundles: Bundle[] = getBundles(state, pdbId);

  return bundles.find(bundle => (bundle.id === bundleId));
};

export const getBundlePrice = (
  state: GlobalState,
  bundleId: ?number = null,
  pdbId: ?string = null,
) => {
  const bundle: ?Bundle = getBundleById(state, pdbId, bundleId);
  return bundle ? bundle.mapped.originalPrice : 0;
};
